import { useFeatureGate } from '@statsig/react-bindings';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';

import { useShareWhiteboardCallback } from '../../components/whiteboard/useShareWhiteboardCallback';
import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { whiteboardEnabledGate } from '../../statsig/gates';
import { participantCountAtom } from '../../video-sdk';
import { isWhiteboardModeAtom } from '../messages/state';
import { useSessionModeCallbacks } from './useSessionModeCallbacks';

export function useWhiteboardControl() {
  const hasParticipants = useAtomValue(participantCountAtom) > 0;
  const { value: isWhiteboardingEnabled } = useFeatureGate(whiteboardEnabledGate);
  const canWhiteboard = hasParticipants && isWhiteboardingEnabled;
  const [startWhiteboarding, { isLoading }] = useShareWhiteboardCallback();
  const { stopCurrentMode: stopWhiteboarding } = useSessionModeCallbacks();
  const isWhiteboardMode = useAtomValue(isWhiteboardModeAtom).value;
  const getIsWhiteboarding = useAtomCallbackMemoized((get) => get(isWhiteboardModeAtom).value, []);

  const toggleWhiteboard = useCallback(() => {
    if (getIsWhiteboarding()) {
      stopWhiteboarding();
    } else {
      startWhiteboarding();
    }
  }, [getIsWhiteboarding, startWhiteboarding, stopWhiteboarding]);

  return {
    canWhiteboard,
    isLoading,
    isWhiteboardMode,
    toggleWhiteboard,
  };
}
